import { http } from '../http';

export type DocumentInfo = {
  location: string;
  displayName: string;
  tenantId: number;
};

export const getDocumentList = async (commercialRelation: string): Promise<DocumentInfo[]> => {
  const response = await http.get<DocumentInfo[]>(
    `/api/v1/documents/commercialrelation/${commercialRelation}/specific`
  );
  return response.data;
};

export const getDocumentExists = async (commercialRelation: string): Promise<boolean | null> => {
  const response = await http.get(
    `/api/v1/documents/commercialrelation/${commercialRelation}/specific/exists`
  );
  return response?.data;
};
